import LoadingSkeleton from "components/elements/Loading/LoadingSkeleton";

export default function ProjectsLoadingSkeleton() {
  return (
    <div>
      <div className="my-1 space-y-4 rounded-lg border border-neutral-200 px-3">
        <div className="flex space-x-4">
          <div className="flex-1 space-y-2">
            <CardLoadingSkeleton />
            <div className="space-y-3 pb-3">
              <div className="rounded-lg border border-neutral-200">
                <div className="my-3 mr-24">
                  <CardLoadingSkeleton />
                  <CardLoadingSkeleton />
                  <CardLoadingSkeleton />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="my-1 space-y-4 rounded-lg border border-neutral-200 px-3">
        <div className="flex space-x-4">
          <div className="flex-1 space-y-2">
            <CardLoadingSkeleton />
            <div className="space-y-3 pb-3">
              <div className="rounded-lg border border-neutral-200">
                <div className="my-3 mr-24">
                  <CardLoadingSkeleton />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="my-1 space-y-4 rounded-lg border border-neutral-200 px-3">
        <div className="flex space-x-4">
          <div className="flex-1 space-y-2">
            <CardLoadingSkeleton />
            <div className="space-y-3 pb-3">
              <div className="rounded-lg border border-neutral-200">
                <div className="my-3 mr-24">
                  <CardLoadingSkeleton />
                  <CardLoadingSkeleton />
                  <CardLoadingSkeleton />
                  <CardLoadingSkeleton />
                  <CardLoadingSkeleton />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function CardLoadingSkeleton() {
  return <LoadingSkeleton className="my-3 h-6" />;
}
